import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './tokens/index.css';
import { SessionProvider } from './lib/session.js';
import { ThemeProvider } from './lib/theme.js';
import { App } from './app/App.js';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <SessionProvider>
        <App />
      </SessionProvider>
    </ThemeProvider>
  </StrictMode>,
);
